import { ArrowRight } from "lucide-react";
import { Photo } from "./Photo";

const SERVICES = [
  {
    id: "reparation-ombyggnad",
    kicker: "Förändra eller laga",
    title: "Reparation & ombyggnad",
    text: "Reparationer och ombyggnader utifrån husets behov och det du vill få gjort.",
  },
  {
    id: "tillbyggnad",
    kicker: "Skapa mer plats",
    title: "Tillbyggnad",
    text: "Tillbyggnader som ger huset mer utrymme.",
  },
  {
    id: "fasad-tak",
    kicker: "Husets utsida",
    title: "Fasad & tak",
    text: "Fasadrenovering och takrenovering – två återkommande delar av Lars byggarbeten.",
  },
  {
    id: "fonster-dorrar",
    kicker: "Förnya husets öppningar",
    title: "Fönster & dörrar",
    text: "Byte av fönster och dörrar.",
  },
  {
    id: "kok-badrum",
    kicker: "Rum att förnya",
    title: "Kök & badrum",
    text: "Köks- och badrumsrenoveringar förekommer också.",
  },
  {
    id: "aldre-hus",
    kicker: "Bevara det som fungerar",
    title: "Varsam renovering av äldre hus",
    text: "Lars har stor vana och ett stort intresse för varsam renovering av äldre hus. Fungerande material får gärna återanvändas.",
    featured: true,
  },
];

export const Services = () => (
  <section id="tjanster" aria-labelledby="tjanster-title" className="overflow-hidden py-20 md:py-24 lg:py-32" data-testid="tjanster-section">
    <div className="container-site">
      <div className="grid gap-12 lg:grid-cols-12 lg:items-center lg:gap-10">
        <div className="reveal lg:col-span-6 xl:col-span-5">
          <p className="eyebrow">Tjänster</p>
          <h2 id="tjanster-title" className="mt-5 max-w-[620px] font-display text-4xl leading-[1.02] tracking-tight text-ink sm:text-5xl lg:text-[4rem]">
            Hjälp med både små och stora byggprojekt
          </h2>
          <p className="lede mt-7 max-w-xl">
            Från reparationer och ombyggnader till fasader, tak och varsam renovering av äldre hus.
          </p>
          <a href="#tjanster-lista" className="btn-primary mt-8">
            Se våra tjänster <ArrowRight size={18} strokeWidth={1.7} className="arrow" aria-hidden="true" />
          </a>
        </div>

        <div className="reveal relative min-h-[500px] sm:min-h-[560px] lg:col-span-6 lg:col-start-7 lg:min-h-[610px] xl:col-span-7 xl:col-start-6">
          <figure className="absolute bottom-0 left-0 top-5 w-[78%] overflow-hidden rounded-[22px] bg-sand shadow-[0_18px_50px_rgba(32,42,36,0.10)]">
            <Photo
              name="projekt-trappa"
              alt="Nybyggd trätrappa och altan vid ett trähus"
              sizes="(min-width: 1024px) 45vw, 78vw"
              position="50% 55%"
            />
          </figure>

          <figure className="absolute right-0 top-0 h-[46%] w-[38%] overflow-hidden rounded-[20px] border-4 border-paper bg-sand shadow-[0_16px_45px_rgba(32,42,36,0.12)]">
            <Photo
              name="projekt-fasad"
              alt="Renoverat trähus med ljus fasad, röda knutar och svart tak"
              sizes="(min-width: 1024px) 25vw, 38vw"
              position="58% 48%"
            />
          </figure>

          <figure className="absolute bottom-5 right-[-1%] h-[36%] w-[38%] overflow-hidden rounded-[20px] border-4 border-paper bg-sand shadow-[0_16px_45px_rgba(32,42,36,0.12)]">
            <Photo
              name="projekt-tillbyggnad"
              alt="Mindre tillbyggnad med ljus träpanel och rött tegeltak"
              sizes="(min-width: 1024px) 25vw, 38vw"
              position="42% 50%"
            />
          </figure>
        </div>
      </div>

      <div id="tjanster-lista" className="mt-24 lg:mt-32">
        <div className="overflow-hidden border border-line bg-paper">
          <div className="grid gap-6 border-b border-line bg-[#f3f0e9] px-6 py-8 sm:px-8 lg:grid-cols-12 lg:items-end lg:px-10 lg:py-10">
            <div className="lg:col-span-5">
              <p className="eyebrow">Vad vi gör</p>
              <h3 className="mt-4 max-w-md font-display text-3xl leading-[1.05] text-ink sm:text-4xl">
                Byggtjänster för huset du har – och det du vill skapa.
              </h3>
            </div>
            <p className="max-w-xl text-base leading-relaxed text-ink2 lg:col-span-5 lg:col-start-8">
              Reparationer, ombyggnader och tillbyggnader – med särskild omsorg om äldre hus och fungerande material.
            </p>
          </div>

          <div>
            {SERVICES.map((service) => (
              <article
                key={service.id}
                className={`reveal group grid gap-5 border-b border-line px-6 py-8 transition-colors duration-200 last:border-b-0 sm:px-8 sm:py-9 lg:grid-cols-12 lg:items-center lg:px-10 lg:py-10 ${service.featured ? "border-l-4 border-l-moss bg-[#EAF3FA]" : "hover:bg-[#f8f6f1]"}`}
                data-testid={`tjanster-card-${service.id}`}
              >
                <div className="lg:col-span-5">
                  <p className="text-[0.68rem] font-semibold uppercase tracking-[0.18em] text-moss">
                    {service.kicker}
                  </p>
                  <h3 className="mt-3 font-display text-3xl leading-[1.06] text-ink transition-colors duration-200 group-hover:text-moss sm:text-[2.35rem]">
                    {service.title}
                  </h3>
                </div>

                <p className="max-w-2xl text-base leading-relaxed text-ink2 lg:col-span-5 lg:col-start-8">
                  {service.text}
                </p>
              </article>
            ))}
          </div>
        </div>

      </div>
    </div>
  </section>
);
